import routes from "./routes";

const fetchEvents = () => 
  fetch(process.env.REACT_APP_API_URL + routes.events.latest())
    .then(res => res.json());

// must be in sync with src/modules/datalayer.js
export default {
  fetchEvents
}